<is-be-auth [environmentKey]="environmentKey" />
<div class="l-app" *ngIf="dispContent; else elseBlock">
    <is-igx-app-header
        [title]="title"
        [titleLink]="titleLink"
        [subTitle]="subTitle"
        [subTitleLink]="subTitleLink"
        [subTitleColor]="subTitleColor"
        [routerItems]="false"
        [navItems]="navItems"
        [navDisable]="navDisable"
        (logout)="logout()"
    />
    <!-- <main class="l-main" [@navOpen]="navDisp ? '' : 'close'"> -->
    <main class="l-main">
        <app-check-server-update></app-check-server-update>
        <router-outlet></router-outlet>
    </main>
</div>
<ng-template #elseBlock>
    <div class="loading-mask">
        <div class="loading-msg">ログイン中...</div>
    </div>
</ng-template>
